// extracted by mini-css-extract-plugin
export var divider = "_xu-0";